import { render, staticRenderFns } from "./dateInput.vue?vue&type=template&id=754a8f28&scoped=true&"
import script from "./dateInput.vue?vue&type=script&lang=js&"
export * from "./dateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754a8f28",
  null
  
)

export default component.exports